import { render, staticRenderFns } from "./CourrierType.vue?vue&type=template&id=cd7e7f64&scoped=true"
import script from "./CourrierType.vue?vue&type=script&lang=js"
export * from "./CourrierType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7e7f64",
  null
  
)

export default component.exports